module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-online-and-magazine-94fedc3a79e2f8a7d01425846bc9b421.png";